var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"form-step-input-title"},[_vm._v(_vm._s(_setup.props.title)),(_setup.props.required)?_c('span',[_vm._v("*")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }